export const DEFAULT_WALL_ID = 'wall-A';

const DEFAULT_WALL = {
  id: DEFAULT_WALL_ID,
  name: 'Wall A',
  placedProducts: [],
  occupiedCells: new Set(),
};

export const _initialState = {
  walls: {
    [DEFAULT_WALL_ID]: DEFAULT_WALL,
  },
  activeWallId: DEFAULT_WALL_ID,
  selectedProduct: null,
};
